import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/** Bridges the billing app-bar refresh action to the active routed billing page. */
@Injectable({ providedIn: 'root' })
export class BillingRefreshService {
  private readonly refreshRequestedSubject = new Subject<void>();

  readonly refreshRequested$ = this.refreshRequestedSubject.asObservable();

  requestRefresh(): void {
    this.refreshRequestedSubject.next();
  }
}
